<template>
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="440px"
             top="30vh">
    <div class="battery-title">{{languages.btDetail}}</div>
    <div class="battery-container">
      <div v-for="(item,index) in detailList"
           :key="index"
           class="battery-detail">
        <div class="item-name">{{languages[item.name]}}:</div>
        <div class="item-detail">{{details[item.data]}}
          <span v-if="item.name==='btDesignCap' || item.name === 'btFullCap'">mWh</span>
        </div>
      </div>
      <div class="battery-detail">
        <div class="item-name">{{languages.btHealth}}:</div>
        <div class="item-important"
             v-if="health!=='X'"
             v-bind:class="health < 60?'danger':'good'">{{health}}
          <span v-if="health && health!=='X'">%</span>
        </div>
      </div>
      <div class="battery-detail">
        <div class="item-name">{{languages.result}}:</div>
        <div class="item-status"
             v-bind:class="health < 60?'danger':'good'">{{getBatteryStatus()}}</div>
      </div>
    </div>

    <span slot="footer">
      <div class="battery-description">
        <div class="desc-name">{{languages.description}}</div>
        <div class="desc-input">
          <el-input size="mini"
                    clearable
                    :disabled="isReporting"
                    :placeholder="languages.reportTips"
                    maxlength="50"
                    v-model="batteryDesc"></el-input>
        </div>
      </div>

      <el-button type="primary"
                 :disabled="isReporting"
                 @click="Hide">{{languages.cancel}}
      </el-button>
      <el-button type="primary"
                 :class="reserveStatus!=='Change'?'hidden':''"
                 :style="lan==='en'?'fontSize:12px':''"
                 @click="Apply">{{languages.deviceApply}}
      </el-button>
      <el-button type="primary"
                 :loading="isReporting"
                 @click="Submit">{{languages.report}}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      isReporting: false,
      batteryDesc: '',
      detailList: [
        { name: 'btName', data: 'DeviceName' },
        { name: 'btManufacture', data: 'ManufactureName' },
        { name: 'btSerial', data: 'SerialNumber' },
        { name: 'btID', data: 'UniqueID' },
        { name: 'btDesignCap', data: 'DesignedCapacity' },
        { name: 'btFullCap', data: 'FullChargeCapacity' },
      ],
    };
  },
  props: {
    lan: String,
    health: String,
    reserveStatus: String,
    details: Object,
    languages: Object,
    show: Boolean,
  },
  methods: {
    getBatteryStatus () {
      switch (this.reserveStatus) {
        case 'Repair':
          return this.languages.btReport;
        case 'Change':
          return this.languages.btChange;
        default:
          return this.languages.btGood;
      }
    },
    Apply () {
      window.location = this.languages.scriptSrc;
      this.$parent.hideBatteryDialog();
    },
    Hide () {
      this.$parent.hideBatteryDialog();
    },
    async Submit () {
      if (this.batteryDesc.trim() === '') {
        this.$message.warning(this.languages.reportTips);
        return;
      }
      this.isReporting = true;
      this.$parent.submitBatteryReport(this.batteryDesc, (result) => {
        this.isReporting = false;
        if (result === 'success') this.batteryDesc = '';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.battery-title {
  position: absolute;
  left: 20px;
  top: 20px;
  font-size: 16px;
  font-weight: 600;
}
.battery-container {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  margin: 30px 20px 10px 20px;
  padding: 5px 0;
  .battery-detail {
    display: flex;
    line-height: 25px;
    .item-name {
      width: 35%;
      // margin-right: 10px;
      text-align: right;
    }
    .item-detail {
      text-align: left;
      margin-left: 10px;
    }
    .item-status {
      margin-left: 10px;
      white-space: pre-wrap;
      width: 250px;
    }
    .item-important {
      text-align: left;
      margin-left: 10px;
      font-size: 16px;
      font-weight: 600;
    }
    .good {
      color: #00b86a;
    }
    .danger {
      color: #f56c6c;
    }
  }
}
.battery-description {
  display: flex;
  line-height: 25px;
  margin: -10px 0 10px 0;
  .desc-name {
    font-size: 14px;
    color: #606266;
    margin-left: 10px;
    width: 80px;
    text-align: right;
  }
  .el-input {
    margin-left: 10px;
    width: 300px;
  }
  .apply-button {
    position: absolute;
    left: 10px;
  }
}
.hidden {
  display: none;
}
</style>
